import React from "react";
import { Grid, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useUser } from "@services/servicesGenericsTables";
import {
  MAutocomplete,
  MDatePicker,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import { KeysTabsAnalysis } from "@app/types/samples.types";

const Not_applicable = () => {
  const form = useFormContext();
  const { userList } = useUser();
  const showForm = form
    .getValues("analysis_type")
    .some((item) => item.codigo === KeysTabsAnalysis.H3_A);

  return (
    <>
      {showForm && (
        <>
          <Grid item xs={12} my={2}>
            <Typography variant="tagText">
              {"Alícuota con muestra sin acidificación"}
            </Typography>
          </Grid>
        </>
      )}

      <ResponsiveFormContainer columns={5} mt={1}>
        <MAutocomplete
          key={JSON.stringify(form.getValues("conditioning_analyst"))}
          name="conditioning_analyst"
          options={userList}
          label="Seleccione un analista"
          getOptionLabel={(option) => option.username || ""}
          validation={{ required: "El analista es requerido" }}
        />
        <MDatePicker
          name="conditioning_date_time"
          pickerType="datetime"
          label="Fecha y hora Inicio"
          validation={{
            required: "La fecha y hora de inicio es requerida",
          }}
        />

        <MTextField
          key={JSON.stringify(
            form.getValues("sample_amount_without_acidification")
          )}
          name="sample_amount_without_acidification"
          placeholder="Cantidad de muestra (ml)"
          label="Cantidad de muestra (ml)"
          type="number"
          fullWidth
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default Not_applicable;
